import { DrawerContainer, FilterHeading } from '@components/Filter';
import { FlexRow } from '@components/FlexRow';
import { Button, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export const FilterDrawer = ({
    children,
    isDrawerOpen,
    toggleDrawer,
    onApplyFilter,
    onResetFilter,
}) => {
    const { handleSubmit } = useFormContext();
    return (
        <Drawer
            anchor="right"
            open={isDrawerOpen}
            onClose={toggleDrawer(false)}>
            <DrawerContainer>
                <FilterHeading justifyContent="space-between">
                    <Typography
                        variant="h6"
                        fontWeight={700}
                        sx={{
                            color: theme =>
                                theme.palette.mode === 'dark'
                                    ? theme.palette.common.white
                                    : theme.palette.darkGrey.main,
                        }}>
                        <i className="fi fi-br-filter" style={{ fontSize: '18px', marginRight: '8px' }} />
                        Filter
                    </Typography>
                    <FlexRow style={{ gap: '0rem' }}>
                        <Button
                            onClick={onResetFilter}
                            sx={{ p: '4px 12px', fontWeight: 700 }}
                            variant="text"
                            color="secondary">
                            Annuler
                        </Button>
                        <IconButton onClick={toggleDrawer(false)} sx={{ p: '4px 6px' }}>
                            <i className="fi-br-cross-small" style={{ fontSize: '18px' }} />
                        </IconButton>
                    </FlexRow>
                </FilterHeading>
                <Stack
                    onSubmit={handleSubmit(onApplyFilter)}
                    component={'form'}
                    justifyContent={'space-between'}
                    flexGrow={1}
                    spacing={2}>
                    <Stack
                        gap={2}
                        sx={{
                            minHeight: '100%',
                            height: 'fit-content',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                        }}>
                        {children}
                        <Button
                            type="submit"
                            sx={{ mt: 'auto', p: '4px 12px', fontWeight: 700 }}
                            variant="contained"
                            color="primary">
                            Appliquer
                        </Button>
                    </Stack>
                </Stack>
            </DrawerContainer>
        </Drawer>
    );
};
